export default __webpack_public_path__ + "static/media/inactiveGridView.4eb69e66.svg";